<template>
  <div class="market-block">
    <div class="market-block__image-wrapper" v-if="(block.type === 'image')">
      <movie-player v-if="block.video" class="market-block__video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
      <img v-if="!block.video" class="market-block__image" :src="block.image" />
    </div>
    <div class="market-block__textwrap" v-if="(block.type === 'text')">
      <h2 class="market-block__title" v-html="block.title"></h2>
      <h3 v-if="block.subtitle" class="market-block__subtitle" v-html="block.subtitle"></h3>
      <div class="market-block__content" v-html="block.content"></div>
    </div>
  </div>
</template>

<script>
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'market-block',
  components: { MoviePlayer },
  props: ['block'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/helpers';

.market-block {
  display: block;
  width: 100%;
  box-sizing: border-box;

  @include tablet {
    width: 75%;

    &:nth-child(2n) {
      margin-left: 25%;
      margin-bottom: 60px;
    }

    &:nth-child(2n+1) {
      margin-right: 25%;
    }
  }

  @include landscape {
    width: 50%;
    margin-bottom: 20px;

    &:nth-child(2n) {
      margin-left: 0;
      margin-bottom: 20px;
    }

    &:nth-child(2n+1) {
      margin-right: 0;
    }
  }

  @include not-tablet {
    width: 50%;
  }

  &__image-wrapper {
    display: block;
    width: calc(100% - 40px);
    // background-size: cover;
    // background-position: center;
    position: relative;
    margin: auto;
    overflow: hidden;

    // &::before {
    //   content: '';
    //   display: block;
    //   padding-top: 56.25%;
    // }

    @include landscape {
      width: calc(100% - 20px);
    }
  }

  @include not-mobile {
    &:nth-child(2n) &__image-wrapper {
      margin-right: 40px;
    }

    &:nth-child(2n+1) &__image-wrapper {
      margin-left: 40px;
    }
  }

  &__image {
    display: block;
    width: 100%;
  }

  // &__video {
    // width: 100%; 
    // height: 100%;
    
    // /* Center the video */
    // position: absolute;
    // top: 0;
    // left: 0;
    // transition: opacity .5s;

    // &.hide {
    //   opacity: 0;
    //   pointer-events: none;
    // }
  // }

  @include landscape {
    &:nth-child(2n) &__image {
      margin-right: 20px;
      margin-left: 0;
    }

    &:nth-child(2n+1) &__image {
      margin-left: 20px;
      margin-right: 0;
    }
  }


  &__textwrap {
    background: $c_white;

    @include mobile {
      width: calc(100% - 20px);
      box-sizing: border-box;
      padding: 40px 30px 40px 60px;
      margin-bottom: 20px;
    }

    @include not-mobile {
      padding: 50px 40px 50px 80px;
    }

    @include landscape {
      box-sizing: border-box;
      padding: 40px 30px 40px 60px;
      width: auto;
      margin-bottom: 0;
    }
  }

  @include tablet {
    &:nth-child(2n) &__textwrap {
      padding: 80px 40px 30px 80px;
      margin-top: -40px;
    }

    &:nth-child(2n+1) &__textwrap {
      padding: 40px 40px 70px 80px;
      margin-bottom: -40px;
    }
  }

  @include landscape {
    &:nth-child(2n) &__textwrap {
      padding: 40px 30px 40px 60px;
      margin-top: 0;
    }

    &:nth-child(2n+1) &__textwrap {
      padding: 40px 30px 40px 60px;
      margin-bottom: 0;
    }
  }

  &__title {
    @include font-block-title;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -40px;
      width: 20px;
      height: 2px;
      background: $c_primary;
      top: 9px;
    }
  }

  &__subtitle {
    @include font-block-subtitle;
  }

  &__content {
    @include font-block-content;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MarketBlock.vue